// src/utils/userSuggest.js
import debounce from "./debounce";
import { UsersService } from "../services";

export const fetchUsers = debounce(async (searchTerm, renderList) => {
    const response = await UsersService.getUsers({ uname: searchTerm });
    if (response?.data.success && Array.isArray(response.data.data)) {
        const matchedPeople = response.data.data
            .map(person => ({
                id: person.user_id,
                value: person.user_name,
                avatar: person.user_image
            }));
        renderList(matchedPeople);
    }
    else{
        renderList([]);
    }
}, 300);